export const golfReservationSearch = (state = {search:[],target:[]}, action) => {
    switch (action.type) {
        case "GOLF_RESERVATION_SEARCH": {
            return action.payload.golfReservationSearch;
        }
        default: {
            return state;
        }
    }
};